/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { PostApiPaymentsYookassaWebhook200, PostApiPaymentsYookassaWebhook400, PostApiPaymentsYookassaWebhook500, PostApiPaymentsYookassaWebhookMutationRequest, PostApiPaymentsYookassaWebhookMutationResponse } from "../entities/PostApiPaymentsYookassaWebhook";
import { modelsErrorResponseSchema } from "./models/errorResponseSchema";
import { yookassaNotificationSchema } from "./yookassa/notificationSchema";
import { z } from "zod/v4";

/**
 * @description OK
 */
export const postApiPaymentsYookassaWebhook200Schema = z.any() as unknown as z.ZodType<PostApiPaymentsYookassaWebhook200>

/**
 * @description Bad Request
 */
export const postApiPaymentsYookassaWebhook400Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<PostApiPaymentsYookassaWebhook400>

/**
 * @description Internal Server Error
 */
export const postApiPaymentsYookassaWebhook500Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<PostApiPaymentsYookassaWebhook500>

/**
 * @description Уведомление ЮKassa
 */
export const postApiPaymentsYookassaWebhookMutationRequestSchema = z.lazy(() => yookassaNotificationSchema) as unknown as z.ZodType<PostApiPaymentsYookassaWebhookMutationRequest>

export const postApiPaymentsYookassaWebhookMutationResponseSchema = z.lazy(() => postApiPaymentsYookassaWebhook200Schema) as unknown as z.ZodType<PostApiPaymentsYookassaWebhookMutationResponse>